import * as Form from '../../components/form'
import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

export const FETCH_EXISTING_SYSTEMS = 'FETCH_EXISTING_SYSTEMS'
export const FETCH_AVAILABLE_SYSTEMS = 'FETCH_AVAILABLE_SYSTEMS'

export const SYSTEM_CREDENTIALS_FORM = 'SYSTEM_CREDENTIALS_FORM'

export const TOGGLE_ADD_SYSTEM_MENU = 'TOGGLE_ADD_SYSTEM_MENU'
export const ADD_SYSTEM = 'ADD_SYSTEM'
export const UPDATE_SYSTEM = 'UPDATE_SYSTEM'
export const UPDATE_SYSTEM_INLINE = 'UPDATE_SYSTEM_INLINE'

export const PLEASE_VERIFY_YOUR_CREDENTIALS = 'Please verify your credentials'
export const UNSUPPORTED_SYSTEM = 'This system is not supported'
export const CREDENTIALS_UPDATED = 'Credentials Updated!'
export const SYSTEM_ACTIVATED = 'System activated!'
export const SYSTEM_CREATED = 'System created!'
export const SYSTEM_SWITCHED_OFF = 'System switched off'
export const SUBSCRIBERS = 'Subscribers'

export const HUBSPOT = 'HubSpot'
export const MAILCHIMP = 'Mailchimp'
export const SALESFORCE = 'Salesforce'

export const NAME = 'name'
export const ID = 'id'

export const FormFieldNames = {
  Key: 'key',
  ListName: 'list_name',
  Name: 'name',
  Secret: 'secret',
  SystemId: 'system_id',
  Token: 'token',
}

export const emptyFormField: Types.FormFields = {
  key: '',
  list_name: '',
  secret: '',
  system_id: null,
  system_name: '',
  token: '',
}

export const FormValidators: Form.FormValidators = {
  [FormFieldNames.Key]: RasaInput.validatePresent,
  [FormFieldNames.ListName]: RasaInput.validatePresent,
  [FormFieldNames.Secret]: RasaInput.validatePresent,
  [FormFieldNames.Token]: RasaInput.validatePresent,
}

export const emptyModalData: Types.ModalData = {
  showAddValidation: false,
}

export const sfSyncTypeToTargetObjectMapping: Types.SyncTypeMapping = {
  Subscribers: 'Contact',
}



// WEBPACK FOOTER //
// ./src/pages/integrations/constants.ts